// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4881c581","239":"52e3630d","667":"2271db61"}[chunkId] + ".chunk.js";
};